import React, { memo } from 'react';
import { useTranslation } from '@dm/i18n';
import { theme } from '../../../index';
import { IconProps, DEFAULT_IMAGE_SIZE } from '../icon';
import IconSvg from '../IconSvg';

const CoinStack = (props: IconProps) => {
  const [t] = useTranslation();
  const {
    id,
    color = theme.palette.color2.hex,
    description = t('ds.icon.coinStack.description'),
    dmId = 'dm-coin-stack',
    pointerEvents = 'none',
    secondColor = theme.palette.color5.hex,
    size = DEFAULT_IMAGE_SIZE,
    title = t('ds.icon.coinStack.title'),
    ...otherProps
  } = props; // we also need to define unused props because of otherProps

  return (
    <IconSvg
      id={id}
      description={description}
      dmId={dmId}
      pointerEvents={pointerEvents}
      size={size}
      title={title}
      {...otherProps}>
      <path
        fill={color}
        d="m15.99 2.577a1 1 0 0 0 -1.325-.477l-12.089 5.633a1 1 0 0 0 -.482 1.324l.458.982 13.9-6.48z"
      />
      <path
        fill={color}
        d="m17.016 11.429c.578 0 1.094.028 1.568.073l.383-.178a1 1 0 0 0 .484-1.324l-2.119-4.545-13.9 6.48 2.119 4.544a1 1 0 0 0 1.324.482l4.158-1.939v-.414c.004-1.187.781-3.179 5.983-3.179z"
      />
      <path
        fill={secondColor}
        d="m21.022 14.708c0-.69-1.682-1.19-4-1.19-2.318 0-4 .5-4 1.19v5.451c.126.281 1.473.857 4 .857s3.873-.576 4-.87z"
      />
      <path
        fill={color}
        d="m17.01 12.518c-.959 0-5 .061-5 2.19v5.451c0 1.352 2.689 1.857 5 1.857s5-.5 5-1.857v-5.451c-.001-2.129-4.041-2.19-5-2.19zm0 1c1.891 0 3.341.336 3.817.833a9.741 9.741 0 0 1 -3.827.674h-.191a8.581 8.581 0 0 1 -3.646-.649c.453-.511 1.922-.858 3.845-.858zm-4 1.857a10.006 10.006 0 0 0 3.81.651h.2a11.622 11.622 0 0 0 3.994-.665v.891a8.986 8.986 0 0 1 -4.014.773h-.191a8.028 8.028 0 0 1 -3.8-.737zm0 2a10.006 10.006 0 0 0 3.81.651h.2a11.623 11.623 0 0 0 4-.665v.89a8.984 8.984 0 0 1 -4.02.774h-.191a8.028 8.028 0 0 1 -3.8-.737zm4 3.641c-2.527 0-3.874-.576-4-.857v-.784a10.006 10.006 0 0 0 3.81.651h.2a11.6 11.6 0 0 0 4-.666v.787c-.137.293-1.484.869-4.011.869z"
      />
    </IconSvg>
  );
};

export default memo(CoinStack);
